<template>
	<b-modal ref="confirm-modal" title="BootstrapVue" hide-footer hide-header-close>
    	<template #modal-title>
			<h5 class="modal-title d-flex align-items-center bdbt pb-2" id="exampleModalLabel">
				<i class="d-flex align-items-center mr-3 ico-orange">
					<svg aria-hidden="true" width="18" height="18" title="">
						<use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="iconId"></use>
					</svg>
				</i>
				<span>{{ title }}</span>
				<button v-if="checkBtn" type="button" class="close" id="khtn" data-dismiss="modal" aria-label="Close" @click="handleKHTN">
                	<span aria-hidden="true">&times;</span>
            	</button>
				<button v-else type="button" class="close" data-dismiss="modal" id="close" aria-label="Close" @click="handleClose">
                	<span aria-hidden="true">&times;</span>
            	</button>
			</h5>
		</template>
		<template #default>
			<p class="clo-black76" v-html="message"></p>
                <div class="modal-footer d-block px-0">
					<div v-if="checkBtn" class="row gutter-10 m-0">
                        <div class="col-12 pr-0">
                            <button  type="button" class="w-100 btn btn-custom orange"  @click="handleOk()">
                                <span class="text-16 text-bold">{{ okBtnText }}</span>
                            </button>
                        </div>
                    </div>
                    <div v-else class="row gutter-10 m-0">
                        <div class="col-6 pl-0" v-if="!hideCancelBtn">
                            <button type="button" class="w-100 btn btn-custom grey" data-dismiss="modal" @click="handleCancel">
                                <span class="text-16 text-bold">{{ cancelBtnText }}</span>
                            </button>
                        </div>
						<div v-if="noti" class="col-12">
                            <button  type="button" class="w-100 btn btn-custom orange"  @click="handleOk()">
                                <span class="text-16 text-bold">{{ okBtnText }}</span>
                            </button>
                        </div>
                        <div v-else class="col-6 pr-0" :class="{'offset-3': hideCancelBtn}">
                            <button  type="button" class="w-100 btn btn-custom orange"  @click="handleOk()">
                                <span class="text-16 text-bold">{{ okBtnText }}</span>
                            </button>
                        </div>
                    </div>		
                </div>
		</template>
  	</b-modal>
</template>

<script>
	export default {
		name: "confirmModal",
		props: {
			title: {
				type: String,
				required: true
			},
            iconId: {
				type: String,
				required: true
			},
            message: {
				type: String,
				required: true
			},
            cancelBtnText: {
				type: String,
			},
            okBtnText: {
				type: String,
				required: true
			},
			hideCancelBtn: {
				type: Boolean,
				default: false
			},
			checkBtn: {
				type: Boolean,
				default: false
			},
			noti: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			showModal () {
				this.$refs['confirm-modal'].show();
			},
            handleClose () {
				this.$refs['confirm-modal'].hide();
			},
			handleOk () {
				this.$emit('click-ok');
				this.$refs['confirm-modal'].hide();
			},
            handleCancel () {
				this.$emit('click-cancel');
				this.$refs['confirm-modal'].hide();
			},
			handleKHTN(){
				this.$emit('click-khtn');
			}
        }
	};
</script>
